import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

export enum DrawerType {
  ASK_GX = 'ASK_GX',
  EXPORT = 'EXPORT'
}

export type DrawerState = {
  openDrawer: DrawerType | null;
  showExportHistory: boolean;
  openedFrom?: string;
};

const initialState: DrawerState = {
  openDrawer: null,
  showExportHistory: false
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    openDrawer: (state, action: PayloadAction<DrawerType>) => {
      state.openDrawer = action.payload;
    },
    openExportDrawer: (
      state,
      action: PayloadAction<{ showHistory?: boolean; source?: string }>
    ) => {
      state.openDrawer = DrawerType.EXPORT;
      state.showExportHistory = action.payload.showHistory ?? false;
      state.openedFrom = action.payload.source;
    },
    setShowExportHistory: (state, action: PayloadAction<boolean>) => {
      state.showExportHistory = action.payload;
    },
    closeDrawer: state => {
      state.openDrawer = null;
      state.showExportHistory = false;
      state.openedFrom = undefined;
    }
  }
});

export const { openDrawer, openExportDrawer, setShowExportHistory, closeDrawer } =
  drawerSlice.actions;
export default drawerSlice.reducer;
